import { MinzeElement, EventListeners, Reactive } from 'minze'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'

Locale.getInstance().registerKeySet('fr', 'discoveryPlacePopup', {
  title: 'Selectionnez un lieu',
  commit: 'Confirmer',
  placeholder: 'Rechercher une ville ou région',
})

Locale.getInstance().registerKeySet('en', 'discoveryPlacePopup', {
  title: 'Select a place',
  commit: 'Confirm',
  placeholder: 'Type a city name or area',
})

export interface LvcDiscoveryPlacePopup {}

export class LvcDiscoveryPlacePopup extends MinzeElement {
  private locationList: any[] = []
  private selectedIndex: number = -1

  onClose() {
    this.remove()
  }

  close() {
    let element = this.select('#modal')
    element?.setAttribute('close', 'true')
  }

  onSet(data: any) {
    MainModule.getInstance().getEE().emit('lvc:discovery_place:set', data)
  }

  async onReady() {
    this.initialize()
  }
  async initialize(): Promise<void> {
    this.loading = true
    this.rerender()
    this.locationList = []
    let geo = MainModule.getInstance().getGeo()

    const currentLocation: any = geo.currentLocation

    if (currentLocation) {
      const locationList = await geo.listNearMe(30000)
      this.locationList = [...locationList]

      for (let i = 0; i < locationList.length; i++) {
        const location = locationList[i]
        if (location.name === currentLocation.name && location.county === currentLocation.county) {
          this.selectedIndex = i
          break
        }
      }
    }
    this.loading = false
    this.rerender()
  }

  async onSearchInput(e: Event): Promise<void> {
    this.loading = true
    this.rerender()
    const input = e.target as HTMLInputElement
    const value = input.value
    this.locationString = value
    const locationList = await MainModule.getInstance().getGeo().list(value)
    this.selectedIndex = -1
    this.locationList = locationList
    this.loading = false
    this.rerender()
  }

  async onSave(): Promise<void> {
    this.loading = true
    this.rerender()

    const location = this.locationList[this.selectedIndex]

    if (location) {
      this.onSet(location)
      this.close()
      return
    }

    this.loading = false
  }

  onSelectItem(e: Event) {
    const item = e.currentTarget as HTMLElement
    const index = item.getAttribute('data-index')
    let i = -1
    try {
      i = parseInt(index as string)
    } catch (e) {
      i = -1
    }
    if (i === this.selectedIndex) {
      this.selectedIndex = -1
    } else {
      this.selectedIndex = i
    }

    this.rerender()
  }

  html = () => {
    let items: string[] = []
    if (this.locationList && this.locationList.length > 0) {
      this.locationList?.map((location, index) => {
        items.push(`
          <div data-index="${index}" class="item-button">
          <span class="location-name">
            ${location.name}
          </span>
          ${this.selectedIndex === index ? `<lvc-check-orange-icon></lvc-check-orange-icon>` : ''}
          </div>
          `)
      })
    }

    return `
    <lvc-closeable-modal theme="neat" id="modal" modal-title="${Locale.getKey('discoveryPlacePopup.title')}">
      <div class="content">
        <div class="search">
          <lvc-search-icon></lvc-search-icon>
          <input type="text" class="lvc-input" placeholder="${Locale.getKey('discoveryPlacePopup.placeholder')}">
        </div>
        <div class="list">
          ${items.join('')}
        </div>
        <div class="lvc-discovery-place-popup-actions">
          <button ${this.loading && `disabled="true"`} class="commit">
            ${Locale.getKey('discoveryPlacePopup.commit')}
          </button>
        </div>
      </div>
    </lvc-closeable-modal>
    `
  }

  css = () => `
    :host {
      display: inline; 
      max-height: 400px;
      font-size: 14px;
    }
    .list {
      overflow-y: auto;
      flex: 1;
      padding: 10px;
      height: 100%;
      max-height: 300px;
    }
    .content {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      height: 25rem;
    }

    .item-button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      cursor: pointer;
      min-height: 40px;
      line-height: 1.5;
      border-bottom: 1px solid #ccc;
    }

    lvc-check-orange-icon{
      display:flex;
    }
    
    .search {
      margin-top: 10px;
      display: flex;
      height: 40px;
      align-items: center;
      padding: 10px;
      border: 1px solid #1E007D;
      border-radius: 50px;
    }

    .search input {
      border: none;
      outline: none;
      padding: 10px;
      width: 100%;
    }

    .commit {
      height: 40px;
      width: 100%;
      border-radius: 50px;
      border: none;
      outline: none;
      background-color: #1E007D;
      color: #fff;
      font-weight: ${Font.weight.bold};
      cursor: pointer;
    }

    .commit:disabled {
      background-color: #ccc;
      color: #fff;
    }



  `

  eventListeners: EventListeners = [
    ['lvc-closeable-modal', 'close', this.onClose.bind(this)],
    ['.lvc-input', 'keyup', this.onSearchInput.bind(this)],
    ['.item-button', 'click', this.onSelectItem.bind(this)],
    ['.commit', 'click', this.onSave.bind(this)],
  ]
}
